import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }
    navigate('/', { state: { scrollTo: sectionId } });
  };

  return (
    <footer className="footer">
      <div className="footer-content row">
        <div className="footer-menu">
          <ul>
            <li>
              <a href="#header-wrapper" onClick={(e) => { e.preventDefault(); scrollToSection('header-wrapper'); }}>
                {t.footer.home}
              </a>
            </li>
            <li>
              <a href="#section-2" onClick={(e) => { e.preventDefault(); scrollToSection('section-2'); }}>
                {t.footer.services}
              </a>
            </li>
            <li>
              <a href="#section-3" onClick={(e) => { e.preventDefault(); scrollToSection('section-3'); }}>
                {t.footer.works}
              </a>
            </li>
            <li>
              <a href="#section-projects" onClick={(e) => { e.preventDefault(); scrollToSection('section-projects'); }}>
                {t.nav.projects}
              </a>
            </li>
            <li>
              <a href="#section-6" onClick={(e) => { e.preventDefault(); scrollToSection('section-6'); }}>
                {t.footer.partners}
              </a>
            </li>
            <li>
              <a href="#section-7" onClick={(e) => { e.preventDefault(); scrollToSection('section-7'); }}>
                {t.footer.contact}
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-copyright">
          <p>{t.footer.rights}</p>
        </div>

        <div className="footer-social">
          <ul>
            <li>
              <a href="https://www.facebook.com/dr.adhamelsharkaawy/" target="_blank" rel="noopener noreferrer" className="facebook">
                <i className="fa fa-facebook" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@adhamelsharkaawy" target="_blank" rel="noopener noreferrer" className="youtube">
                <i className="fa fa-youtube" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/dradhambis" target="_blank" rel="noopener noreferrer" className="twitter">
                <i className="fa fa-twitter" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/dr.adhamelsharkawy/" target="_blank" rel="noopener noreferrer" className="instagram">
                <i className="fa fa-instagram" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
